import { Fragment, useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, CardTitle, Col, FormGroup, Input, Label, Row } from "reactstrap";
import BaseService from "../../../../../services/baseService";
import { actions as actionsSite } from "../../../../../redux/actions/site";
import SelectUf from "../../../../../components/Select/SelectUf/index";
import SelectSexo from "../../../../../components/Select/SelectSexo/index";
import SelectEstadoCivil from "../../../../../components/Select/SelectEstadoCivil/index";
import SelectTipoContratoSophus from "../../../../../components/Select/SelectTipoContratoSophus";
import SelectMunicipio from "../../../../../components/Select/SelectMunicipio/index";
import { options as optionsMunicipio } from "../../../../../components/Select/SelectMunicipio/options";
import { options as optionsUf } from "../../../../../components/Select/SelectUf/options";
import { options as optionsSexo } from "../../../../../components/Select/SelectSexo/options";
import { options as optionsEstadoCivil } from "../../../../../components/Select/SelectEstadoCivil/options";
import { optionsPF as optionsTipoContratoPF } from "../../../../../components/Select/SelectTipoContratoSophus/options";
import Error from "../../../../../components/messagesModal/error";
import Success from "../../../../../components/messagesModal/success";
import RetryQuery from "../../../../../components/messagesModal/retryQuery";
import ErrorZeroBalance from "../../../../../components/messagesModal/errorZeroBalance";

const baseService = new BaseService("consulta");

const Step3 = ({ query, values, setCurrentStep }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [sexoValue, setSexoValue] = useState();
  const [estadoCivilValue, setEstadoCivilValue] = useState();
  const [naturalidadeUfValue, setNaturalidadeUfValue] = useState();
  const [ufValue, setUfValue] = useState();
  const [tipoContratoValue, setTipoContratoValue] = useState();
  const [naturalidadeValue, setNaturalidadeValue] = useState();

  const [formData, setFormData] = useState({
    nome: '',
    cpf: '',
    data_nascimento: '',
    sexo: '',
    estado_civil: '',
    naturalidade: '',
    naturalidade_uf: '',
    cep: '',
    uf: '',
    cidade: '',
    bairro: '',
    logradouro: '',
    numero: '',
    complemento: '',
    email: '',
    tipo_contrato: '',
    contrato: '',
    data_vencimento: '',
    data_venda: '',
    valor: '',
    observacao: '',
  });

  const handleSetSexoValue = (value) => {
    const _sexoValue = optionsSexo.find(s => s.value === value);
    setSexoValue(_sexoValue);
  }

  const handleSetEstadoCivilValue = (value) => {
    const _estadoCivilValue = optionsEstadoCivil.find(e => e.value === value);
    setEstadoCivilValue(_estadoCivilValue);
  }

  const handleSetNaturalidadeUfValue = (value) => {
    const _naturalidadeUfValue = optionsUf.find(uf => uf.value === value);
    setNaturalidadeUfValue(_naturalidadeUfValue);
  }

  const handleSetNaturalidadeValue = (value) => {
    const _naturalidadeValue = optionsMunicipio.find(opt => opt.value === value);
    setNaturalidadeValue(_naturalidadeValue);
  }

  const handleSetUfValue = (value) => {
    const _uf = optionsUf.find(uf => uf.value === value);
    setUfValue(_uf);
  }

  const handleSetTipoContratoValue = (value) => {
    const _tipoContratoValue = optionsTipoContratoPF.find(opt => opt.value === value);
    setTipoContratoValue(_tipoContratoValue);
  }

  useEffect(() => {
    if (values.sexo) {
      handleSetSexoValue(values.sexo);
    }

    if (values.estado_civil) {
      handleSetEstadoCivilValue(values.estado_civil);
    }

    if (values.naturalidade_uf) {
      handleSetNaturalidadeUfValue(values.naturalidade_uf);
    }

    if (values.naturalidade) {
      handleSetNaturalidadeValue(values.naturalidade);
    }

    if (values.uf) {
      handleSetUfValue(values.uf);
    }

    if (values.tipo_contrato) {
      handleSetTipoContratoValue(values.tipo_contrato);
    }

    setFormData({
      nome: values.nome,
      cpf: values.cpf,
      data_nascimento: values.data_nascimento,
      sexo: values.sexo,
      estado_civil: values.estado_civil,
      naturalidade: values.naturalidade,
      naturalidade_uf: values.naturalidade_uf,
      cep: values.cep,
      uf: values.uf,
      cidade: values.cidade,
      bairro: values.bairro,
      logradouro: values.logradouro,
      numero: values.numero,
      complemento: values.complemento,
      email: values.email,
      tipo_contrato: values.tipo_contrato,
      contrato: values.contrato,
      data_vencimento: values.data_vencimento,
      data_venda: values.data_venda,
      valor: values.valor,
      observacao: values.observacao
    });
  }, [values])

  const goOrderPayment = useCallback(() => {
    dispatch(actionsSite.closeModal());
    history.push("/financeiro/ordens-de-pagamento");
  },[dispatch, history]);

  const showMessageModal = useCallback(({ error, msg, icon=null, loadingCar=false }) => {
    const CompError = msg.includes('Sem saldo para realizar') ? ErrorZeroBalance : Error ;
    const configModal = {
      component: error ? <CompError msg={msg} goOrderPayment={goOrderPayment} /> : <Success msg={msg} icon={icon} loadingCar={loadingCar} />,
      title: error ? `Erro` : `Sucesso`,
    };
    dispatch(actionsSite.setModal(configModal));
  },[dispatch, goOrderPayment]);

  const execute = async () => {
    try {
      values.cpf = values.cpf.replace(/[./-]/g, "");
      values.valor = values.valor.replace(".", "");

      showMessageModal({ error: false, msg: "Enviando Negativação, por favor aguarde" });

      baseService._postConsulta(`${baseService.route}/${query.code}`, values)
        .then((res) => {
          if (res.success === false && res.duplicatedQuery) {
            const configModal = {
              component: <RetryQuery logquery={res.logqueryOrigin} msg={res.msg} execute={execute} values={values}/>,
              title: 'Suspeita de consulta em duplicidade',
            };
            dispatch(actionsSite.setModal(configModal));
            return;
          }

          showMessageModal({ error: !res.success, msg: res.msg });
          if (res.success) {
            history.push("/historico/" + res.logQuery);
          }
        })
        .catch((error) => {
          if (error.response) {
            showMessageModal({ error: true, msg: error.response.data.msg })
          }
        });
    } catch (e) {
      console.log(e.toString());
    }
  };

  return (
    <Fragment>
      <Card className="border-custom">
        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados Pessoais do Devedor</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="cpf">CPF</Label>
                <Input type="text" className={"form-control"} value={formData.cpf} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="nome">Nome</Label>
                <Input type="text" className={"form-control"} value={formData.nome} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="data_nascimento">Data Nascimento</Label>
                <Input type="text" className={"form-control"} value={formData.data_nascimento} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="sexo">Sexo</Label>
                <SelectSexo value={sexoValue} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="estado_civil">Estado Civil</Label>
                <SelectEstadoCivil value={estadoCivilValue} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="naturalidade_uf">UF Naturalidade</Label>
                <SelectUf value={naturalidadeUfValue} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="naturalidade">Cidade Naturalidade</Label>
                <SelectMunicipio value={naturalidadeValue} disabled={true}/>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Endereço do Devedor</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="cep">Cep</Label>
                <Input type="text" className={"form-control"} value={formData.cep} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="uf">UF</Label>
                <SelectUf value={ufValue} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="cidade">Cidade</Label>
                <Input type="text" className={"form-control"} value={formData.cidade} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="bairro">Bairro</Label>
                <Input type="text" className={"form-control"} value={formData.bairro} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="logradouro">Logradouro</Label>
                <Input type="text" className={"form-control"} value={formData.logradouro} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="numero">Número</Label>
                <Input type="text" className={"form-control"} value={formData.numero} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="complemento">Complemento</Label>
                <Input type="text" className={"form-control"} value={formData.complemento} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="email">Email</Label>
                <Input type="text" className={"form-control"} value={formData.email} disabled={true}/>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados da Dívida</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="tipo_contrato">Tipo Contrato</Label>
                <SelectTipoContratoSophus value={tipoContratoValue} typeOptions={"PF"} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="contrato">Contrato</Label>
                <Input type="text" className={"form-control"} value={formData.contrato} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="data_vencimento">Data de Vencimento</Label>
                <Input type="text" className={"form-control"} value={formData.data_vencimento} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="data_venda">Data de Venda</Label>
                <Input type="text" className={"form-control"} value={formData.data_venda} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
              <Label htmlFor="valor">Valor R$</Label>
                <Input type="text" className={"form-control"} value={formData.valor} disabled={true}/>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="observacao">Observação</Label>
                <Input type="text" className={"form-control"} value={formData.observacao} disabled={true}/>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card className="border-custom">
        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Enviar Negativação</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <h2>Você tem certeza que os dados preenchidos estão corretos?</h2>
              <h2>Se SIM, clique em "Enviar" para confirmar o envio da Negativação.</h2>
              <h2>Se NÃO, clique em "Anterior" e revise os dados.</h2>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div className="text-center">
        <Button className="mr-1" color="primary" onClick={() => setCurrentStep(1)}>Anterior</Button>
        <Button className="mr-1" color="success" onClick={execute}>Enviar</Button>
      </div>
    </Fragment>
  );
};

export default Step3;